@if (_showPicker) {
    <div
        class="agpr-advancedColorPickerField agpr-formField agpr-colorPickerField"
        [class.agpr-advancedColorPickerField--disabled]="field.disabled"
        [class.agpr-advancedColorPickerField--inline]="field.inline">
        <!-- Label -->
        @if (field.label) {
            <div
                [id]="id + '_colorPicker_label'"
                class="agpr-advancedColorPickerField-label agpr-formField-label">
                    {{ field.label | localize }}
            </div>
        }
        <div class="agpr-advancedColorPickerField-inputContainer">
            <agpr-color-picker-trigger
                [id]="id"
                [value]="value"
                (valueWithTypeChange)="onColorSelectedWithType($event)"
                [isOpen]="isPopoverOpen"
                (isOpenChange)="onPopoverOpenChange($event)"
                [showFavoriteColors]="field.showFavoriteColors"
                [showRecentColors]="{
                    show: field.showRecentColors,
                    property: field.property
                }"
                (favoriteColorsChange)="onfavoriteColorsChange($event)"
                [brandId]="brandId"
            >
                <div
                    [id]="id + '_colorPicker_popover_open'"
                    [agprTooltip]="field.tooltip"
                    [tooltipPosition]="field.tooltipPosition"
                    [attr.aria-label]="(field.ariaLabel || 'ColorPicker.openColorPicker') | localize"
                    class="agpr-advancedColorPickerField-button"
                    [class.agpr-advancedColorPickerField-button--open]="isPopoverOpen"
                    role="button"
                    tabindex="0"
                    aria-haspopup="dialog"
                    [attr.aria-expanded]="isPopoverOpen"
                >
                    <!-- Color Swatch -->
                    @if (field.icon) {
                        <span [ngClass]="['agpr-advancedColorPickerField-icon', 'agpr-button-icon', field.icon]"  [attr.aria-hidden]="true"></span>
                    }
                    <div class="agpr-advancedColorPickerField-button-swatch" [style.background-color]="value" role="img"  [attr.aria-hidden]="true"></div>
                </div>
            </agpr-color-picker-trigger>
            <!-- Color Input -->
            <div class="agpr-advancedColorPickerField-valueWrapper">
                <span>#</span>
                <input
                    #colorInput
                    class="agpr-advancedColorPickerField-value"
                    [attr.aria-label]="'ColorPicker.colorName.label' | localize"
                    [id]="id + '_selectedColor'"
                    [class.agpr-advancedColorPickerField-value---hasIcon]="field.icon"
                    [value]="inputValue"
                    (input)="onHexInputValue($event)"
                    (copy)="onHexInputCopy($event)"
                    (focus)="onHexInputFocus($event)"
                    (focusout)="onHexFocusOut($event)"
                    (keydown.enter)="onHexInputEnter($event)"
                    type="text"
                    [attr.maxlength]="INPUT_MAX_SIZE + 1" />
                @if (inputValue && field.showDeleteButton) {
                    <agpr-button
                        class="agpr-advancedColorPickerField-value-delete"
                        [id]="id + '_deleteColor'"
                        icon="fa-regular fa-duotone fa-trash-can"
                        [style]="buttonTypes.icon"
                        ariaLabel="ColorPicker.deleteColor.button"
                        (click)="deleteFavoriteColor(value)"
                    ></agpr-button>
                }
            </div>
        </div>
    </div>
}

